import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5af45c08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video-consultation" }
const _hoisted_2 = {
  key: 0,
  class: "lobby"
}
const _hoisted_3 = { class: "lobby-actions" }
const _hoisted_4 = { class: "permission-status" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "摄像头", -1))
const _hoisted_6 = { class: "permission-text" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "麦克风", -1))
const _hoisted_8 = { class: "permission-text" }
const _hoisted_9 = {
  key: 0,
  class: "permission-notice"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请使用 HTTPS 或 localhost 访问", -1))
const _hoisted_11 = {
  key: 1,
  class: "permission-tip"
}
const _hoisted_12 = { class: "lobby-preview" }
const _hoisted_13 = {
  key: 0,
  class: "preview-mask"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "摄像头未就绪", -1))
const _hoisted_15 = { class: "lobby-form" }
const _hoisted_16 = {
  key: 1,
  class: "room"
}
const _hoisted_17 = {
  key: 0,
  class: "remote-placeholder"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "等待医生接入...", -1))
const _hoisted_19 = { class: "call-info" }
const _hoisted_20 = { class: "call-timer" }
const _hoisted_21 = { class: "call-status" }
const _hoisted_22 = { class: "action-bar" }
const _hoisted_23 = { class: "action-icon" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "翻转", -1))
const _hoisted_25 = { class: "action-icon hang-up-icon" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "挂断", -1))
const _hoisted_27 = { class: "end-dialog-content" }

import { ref, computed, onMounted, onBeforeUnmount, nextTick } from 'vue'
import { showToast, showDialog } from 'vant'
import { useRoute } from 'vue-router'
import TRTC from 'trtc-sdk-v5'


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoConsultation',
  setup(__props) {

const route = useRoute()

// ---- 状态 ----
const userId = ref('')
const roomId = ref('')
const userSig = ref('')
const inRoom = ref(false)
const joining = ref(false)
const cameraReady = ref(false)
const remoteStreamReady = ref(false)
const isMuted = ref(false)
const cameraOn = ref(true)
const callDuration = ref(0)
const showEndDialog = ref(false)

// ---- 权限状态 ----
const cameraPermission = ref<'granted' | 'denied' | 'prompt'>('prompt')
const micPermission = ref<'granted' | 'denied' | 'prompt'>('prompt')
const requestingPermissions = ref(false)

// ---- DOM 引用 ----
const lobbyLocalView = ref<HTMLElement>()
const localView = ref<HTMLElement>()
const remoteView = ref<HTMLElement>()

// ---- TRTC 实例 ----
let trtc: TRTC | null = null
let timer: ReturnType<typeof setInterval> | null = null

// ---- 计算属性 ----
const formattedDuration = computed(() => {
  const h = Math.floor(callDuration.value / 3600)
  const m = Math.floor((callDuration.value % 3600) / 60)
  const s = callDuration.value % 60
  const pad = (n: number) => String(n).padStart(2, '0')
  return h > 0 ? `${pad(h)}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`
})

const callStatusText = computed(() => {
  if (remoteStreamReady.value) return '问诊中'
  return '等待接入'
})

const permissionsReady = computed(() => {
  return cameraPermission.value === 'granted' && micPermission.value === 'granted'
})

const isSecureEnv = computed(() => {
  return window.location.hostname === 'localhost' ||
         window.location.hostname === '127.0.0.1' ||
         window.location.protocol === 'https:'
})

// ---- 初始化 ----
onMounted(async () => {
  document.title = '视频问诊'
  // 从 URL 参数中获取房间信息（使用 Vue Router 的 route.query）
  if (route.query.userId) userId.value = String(route.query.userId)
  if (route.query.roomId) roomId.value = String(route.query.roomId)
  if (route.query.userSig) userSig.value = String(route.query.userSig)

  console.log('URL 参数:', { userId: userId.value, roomId: roomId.value, userSig: userSig.value ? '已设置' : '未设置' })

  // 初始化 TRTC SDK
  await initTRTC()
})

onBeforeUnmount(() => {
  cleanup()
})

// ---- 权限管理 ----
function updatePermissionStatus(granted: boolean) {
  if (granted) {
    cameraPermission.value = 'granted'
    micPermission.value = 'granted'
  } else {
    cameraPermission.value = 'denied'
    micPermission.value = 'denied'
  }
}

async function requestPermissions() {
  if (requestingPermissions.value) return
  
  requestingPermissions.value = true
  
  try {
    // 检测是否为安全环境（HTTPS 或 localhost）
    if (!isSecureEnv.value) {
      showToast('请使用 HTTPS 或 localhost 访问以获取摄像头权限')
      updatePermissionStatus(false)
      requestingPermissions.value = false
      return
    }

    // 直接使用 TRTC SDK 启动本地视频来获取权限
    if (!trtc) {
      trtc = TRTC.create()
    }

    // 先停止已有的视频流，防止重复启动
    try {
      await trtc.stopLocalVideo()
    } catch (e) {
      // 忽略停止失败的情况（可能还没启动）
    }

    await trtc.startLocalVideo({
      option: { profile: '480p' },
      view: lobbyLocalView.value
    })

    updatePermissionStatus(true)
    cameraReady.value = true
    showToast('权限获取成功')
  } catch (err: any) {
    console.error('权限获取失败:', err)
    updatePermissionStatus(false)
    
    if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
      showToast('权限被拒绝，请在浏览器设置中允许')
    } else if (err.name === 'NotFoundError' || err.name === 'DevicesNotFoundError') {
      showToast('未检测到摄像头或麦克风设备')
    } else {
      showToast('权限获取失败：' + err.message)
    }
  } finally {
    requestingPermissions.value = false
  }
}

function getPermissionText(status: 'granted' | 'denied' | 'prompt') {
  switch (status) {
    case 'granted':
      return '已允许'
    case 'denied':
      return '已拒绝'
    case 'prompt':
      return '未获取'
    default:
      return '未知'
  }
}

// ---- TRTC 初始化 ----
async function initTRTC() {
  try {
    trtc = TRTC.create()
    
    // 监听远端流事件
    trtc.on(TRTC.EVENT.REMOTE_VIDEO_AVAILABLE, (event: any) => {
      const { userId: remoteUserId, streamType } = event
      nextTick(() => {
        if (remoteView.value && trtc) {
          trtc.startRemoteVideo({
            userId: remoteUserId,
            streamType,
            view: remoteView.value
          })
          remoteStreamReady.value = true
        }
      })
    })

    trtc.on(TRTC.EVENT.REMOTE_VIDEO_UNAVAILABLE, () => {
      remoteStreamReady.value = false
    })

    trtc.on(TRTC.EVENT.REMOTE_USER_LEAVE, () => {
      remoteStreamReady.value = false
      showToast('对方已离开')
    })

    trtc.on(TRTC.EVENT.KICKED_OUT, () => {
      showToast('您已被踢出房间')
      handleLeaveRoom()
    })

    trtc.on(TRTC.EVENT.ERROR, (error: any) => {
      console.error('TRTC Error:', error)
    })

    // 预览本地摄像头
    await startLocalPreview()
  } catch (e) {
    console.error('TRTC 初始化失败:', e)
  }
}

async function startLocalPreview() {
  try {
    if (!trtc) {
      trtc = TRTC.create()
    }
    
    await nextTick()
    if (lobbyLocalView.value) {
      await trtc.startLocalVideo({
        option: { profile: '480p' },
        view: lobbyLocalView.value
      })
      cameraReady.value = true
      cameraPermission.value = 'granted'
      micPermission.value = 'granted'
    }
  } catch (e: any) {
    console.warn('本地摄像头预览失败:', e)
    cameraReady.value = false
    // 权限未获取，用户可以点击按钮重试
    cameraPermission.value = 'prompt'
    micPermission.value = 'prompt'
  }
}

// ---- 进入房间 ----
async function enterRoom() {
  if (!userId.value) {
    showToast('请输入用户ID')
    return
  }
  if (!roomId.value) {
    showToast('请输入房间号')
    return
  }
  if (!userSig.value) {
    showToast('请输入用户签名')
    return
  }

  joining.value = true
  try {
    // 停止大厅预览
    if (trtc) {
      await trtc.stopLocalVideo()
    }

    // 根据房间号类型选择合适的参数
    const isNumeric = /^-?\d+$/.test(roomId.value)
    const roomParams: Record<string, string | number> = {}
    
    if (isNumeric) {
      roomParams.roomId = Number(roomId.value)
    } else {
      roomParams.roomIdStr = roomId.value
    }

    await trtc?.enterRoom({
      ...roomParams,
      sdkAppId: 1400532059,
      userId: userId.value,
      userSig: userSig.value
    })

    inRoom.value = true

    // 启动本地视频（通话中的小窗）
    await nextTick()
    if (localView.value && trtc) {
      await trtc.startLocalVideo({
        option: { profile: '480p' },
        view: localView.value
      })
    }

    // 启动本地音频
    await trtc?.startLocalAudio()

    // 开始计时
    startTimer()
  } catch (e: any) {
    console.error('进入房间失败:', e)
    // 根据 TRTC 错误码提供更详细的错误提示
    const errorMsg = getTRTCErrorMessage(e)
    showToast('进入房间失败：' + errorMsg)
    // 恢复大厅预览
    await startLocalPreview()
  } finally {
    joining.value = false
  }
}

function getTRTCErrorMessage(error: any): string {
  const code = error?.code || error?.result
  const message = error?.message || error?.error || '未知错误'
  
  const errorMap: Record<number | string, string> = {
    70001: '参数错误，请检查房间号、用户ID和签名',
    70002: '网络错误，请检查网络连接',
    70003: 'UserSig 签名非法，请重新生成签名。参考文档：https://cloud.tencent.com/document/product/269/32688',
    70004: 'SDKAppID 不存在或已过期',
    70005: '签名已过期，请重新生成',
    70006: '签名签名不正确',
    70007: '房间号非法',
    70008: '用户ID非法',
    70009: '签名中的用户ID与传入的用户ID不一致',
    70010: '签名中的SDKAppID与传入的不一致',
    70011: '签名中的房间号与传入的不一致',
    70012: '签名中的过期时间与传入的不一致',
    70013: '签名中的权限不足',
    70014: '签名中的时间戳与当前时间相差过大',
    70015: '签名中的随机数与传入的不一致',
    70016: '签名中的签名算法不支持',
    70017: '签名中的签名版本不支持',
    70018: '签名中的签名参数不完整',
    70019: '签名中的签名参数格式错误',
    70020: '签名中的签名参数值错误',
    10001: '房间已满',
    10002: '房间不存在',
    10003: '房间已关闭',
    10004: '用户已在房间中',
    10005: '用户被踢出房间',
    10006: '用户被禁言',
    10007: '用户被封禁',
    10008: '用户被踢出后无法再次进入',
    10009: '用户被踢出后需要等待一段时间才能再次进入',
    10010: '用户被踢出后需要重新获取签名才能再次进入',
  }

  if (code && errorMap[code]) {
    return errorMap[code]
  }
  
  return message
}

// ---- 离开房间 ----
async function leaveRoom() {
  try {
    await showDialog({
      title: '确认挂断',
      message: '确定要结束本次问诊吗？'
    })
    await handleLeaveRoom()
    showEndDialog.value = true
  } catch {
    // 用户取消
  }
}

async function handleLeaveRoom() {
  stopTimer()
  try {
    await trtc?.stopLocalVideo()
    await trtc?.stopLocalAudio()
    await trtc?.exitRoom()
  } catch (e) {
    console.warn('退出房间异常:', e)
  }
  inRoom.value = false
  remoteStreamReady.value = false
  // 恢复大厅预览
  await nextTick()
  await startLocalPreview()
}

function onEndConfirm() {
  showEndDialog.value = false
  callDuration.value = 0
}

// ---- 操作控制 ----
async function toggleMute() {
  if (!trtc) return
  try {
    if (isMuted.value) {
      await trtc.startLocalAudio()
      isMuted.value = false
    } else {
      await trtc.stopLocalAudio()
      isMuted.value = true
    }
  } catch (e) {
    console.error('切换静音失败:', e)
  }
}

async function toggleCamera() {
  if (!trtc) return
  try {
    if (cameraOn.value) {
      await trtc.stopLocalVideo()
      cameraOn.value = false
    } else {
      const view = localView.value
      if (view) {
        await trtc.startLocalVideo({
          option: { profile: '480p' },
          view
        })
      }
      cameraOn.value = true
    }
  } catch (e) {
    console.error('切换摄像头失败:', e)
  }
}

async function switchCamera() {
  if (!trtc) return
  try {
    await trtc.switchDevice({
      mediaType: 'video',
      deviceType: 'frontCamera'
    })
  } catch (e) {
    console.warn('翻转摄像头失败:', e)
  }
}

// ---- 计时器 ----
function startTimer() {
  callDuration.value = 0
  timer = setInterval(() => {
    callDuration.value++
  }, 1000)
}

function stopTimer() {
  if (timer) {
    clearInterval(timer)
    timer = null
  }
}

// ---- 清理 ----
function cleanup() {
  stopTimer()
  if (trtc) {
    trtc.stopLocalVideo().catch(() => {})
    trtc.stopLocalAudio().catch(() => {})
    trtc.exitRoom().catch(() => {})
    trtc.destroy()
    trtc = null
  }
}

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_dialog = _resolveComponent("van-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!inRoom.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_van_button, {
              type: "primary",
              block: "",
              round: "",
              loading: joining.value,
              onClick: enterRoom
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 进入问诊室 ")
              ]),
              _: 1
            }, 8, ["loading"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass(["permission-item", { granted: cameraPermission.value === 'granted', denied: cameraPermission.value === 'denied' }])
            }, [
              _createVNode(_component_van_icon, {
                name: cameraPermission.value === 'granted' ? 'check-circle-o' : (cameraPermission.value === 'denied' ? 'close-circle-o' : 'video-o'),
                color: cameraPermission.value === 'granted' ? '#07c160' : (cameraPermission.value === 'denied' ? '#f44' : '#999'),
                size: "20"
              }, null, 8, ["name", "color"]),
              _hoisted_5,
              _createElementVNode("span", _hoisted_6, _toDisplayString(getPermissionText(cameraPermission.value)), 1)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["permission-item", { granted: micPermission.value === 'granted', denied: micPermission.value === 'denied' }])
            }, [
              _createVNode(_component_van_icon, {
                name: micPermission.value === 'granted' ? 'check-circle-o' : (micPermission.value === 'denied' ? 'close-circle-o' : 'sound-o'),
                color: micPermission.value === 'granted' ? '#07c160' : (micPermission.value === 'denied' ? '#f44' : '#999'),
                size: "20"
              }, null, 8, ["name", "color"]),
              _hoisted_7,
              _createElementVNode("span", _hoisted_8, _toDisplayString(getPermissionText(micPermission.value)), 1)
            ], 2),
            (!_unref(isSecureEnv))
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_van_icon, {
                    name: "warning-o",
                    color: "#ff976a",
                    size: "16"
                  }),
                  _hoisted_10
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_van_button, {
              type: "primary",
              size: "small",
              onClick: requestPermissions,
              loading: requestingPermissions.value,
              disabled: !_unref(isSecureEnv)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(requestingPermissions.value ? '获取中...' : '获取权限'), 1)
              ]),
              _: 1
            }, 8, ["loading", "disabled"]),
            (cameraPermission.value === 'denied' || micPermission.value === 'denied')
              ? (_openBlock(), _createElementBlock("p", _hoisted_11, " 权限被拒绝，请在浏览器设置中允许摄像头和麦克风权限后刷新页面 "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", {
              class: "local-preview",
              ref_key: "lobbyLocalView",
              ref: lobbyLocalView
            }, null, 512),
            (!cameraReady.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_van_icon, {
                    name: "photo-o",
                    size: "48",
                    color: "#999"
                  }),
                  _hoisted_14
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_van_cell_group, { inset: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_van_field, {
                  modelValue: userId.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userId).value = $event)),
                  label: "用户ID",
                  placeholder: "请输入用户ID",
                  rules: [{ required: true, message: '请输入用户ID' }]
                }, null, 8, ["modelValue"]),
                _createVNode(_component_van_field, {
                  modelValue: roomId.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((roomId).value = $event)),
                  label: "房间号",
                  placeholder: "请输入房间号",
                  rules: [{ required: true, message: '请输入房间号' }]
                }, null, 8, ["modelValue"]),
                _createVNode(_component_van_field, {
                  modelValue: userSig.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((userSig).value = $event)),
                  label: "用户签名",
                  placeholder: "请输入UserSig",
                  type: "textarea",
                  rows: "2",
                  autosize: "",
                  rules: [{ required: true, message: '请输入UserSig' }]
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", {
            class: "remote-video",
            ref_key: "remoteView",
            ref: remoteView
          }, null, 512),
          (!remoteStreamReady.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(_component_van_icon, {
                  name: "manager-o",
                  size: "64",
                  color: "#ccc"
                }),
                _hoisted_18
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "local-video",
            ref_key: "localView",
            ref: localView,
            onClick: switchCamera
          }, null, 512),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(formattedDuration)), 1),
            _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(callStatusText)), 1)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", {
              class: "action-item",
              onClick: toggleMute
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["action-icon", { active: isMuted.value }])
              }, [
                _createVNode(_component_van_icon, {
                  name: isMuted.value ? 'closed-eye' : 'eye-o',
                  size: "24"
                }, null, 8, ["name"])
              ], 2),
              _createElementVNode("span", null, _toDisplayString(isMuted.value ? '已静音' : '静音'), 1)
            ]),
            _createElementVNode("div", {
              class: "action-item",
              onClick: toggleCamera
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["action-icon", { active: !cameraOn.value }])
              }, [
                _createVNode(_component_van_icon, {
                  name: cameraOn.value ? 'video' : 'video-o',
                  size: "24"
                }, null, 8, ["name"])
              ], 2),
              _createElementVNode("span", null, _toDisplayString(cameraOn.value ? '关闭摄像头' : '开启摄像头'), 1)
            ]),
            _createElementVNode("div", {
              class: "action-item",
              onClick: switchCamera
            }, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_van_icon, {
                  name: "replay",
                  size: "24"
                })
              ]),
              _hoisted_24
            ]),
            _createElementVNode("div", {
              class: "action-item hang-up",
              onClick: leaveRoom
            }, [
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_van_icon, {
                  name: "phone-o",
                  size: "24",
                  color: "#fff"
                })
              ]),
              _hoisted_26
            ])
          ])
        ])),
    _createVNode(_component_van_dialog, {
      show: showEndDialog.value,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((showEndDialog).value = $event)),
      title: "问诊结束",
      showConfirmButton: true,
      confirmButtonText: "确定",
      onConfirm: onEndConfirm
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_van_icon, {
            name: "passed",
            size: "48",
            color: "#07c160"
          }),
          _createElementVNode("p", null, "本次问诊时长：" + _toDisplayString(_unref(formattedDuration)), 1)
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})